import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { PrimaryButton } from '../ui/PrimaryButton';
import { scrollToId } from '../../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-bg-primary pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-104" data-mp="cv32tt32i8e9">
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-105" data-mp="hvz21tch56dc">
        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-106" data-mp="mt9202xhp0ff">
          <SectionTag icon="🪵" data-id="element-107" data-mp="qu2s92yemrbh">Para carpinteros y manitas con taller en casa</SectionTag>
        </m.div>

        <m.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 font-heading text-4xl font-extrabold uppercase leading-[1.08] tracking-tight text-ink sm:text-5xl md:text-6xl" data-id="element-108" data-mp="vn48pfe9eyx6">
          De retales olvidados a <span className="text-brown" data-id="element-109" data-mp="1ah8rkzj2eksf">piezas de diseño</span>.
        </m.h1>

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.18
      }} className="mt-5 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-110" data-mp="9p42juhhpl6w">
          Los productos que se venden solos en España. Transforma tus retales acumulados en más de{' '}
          <span className="font-semibold text-ink" data-id="element-111" data-mp="setwyghcc4ya">500€/mes</span> con micro-productos de alta demanda.
        </m.p>

        {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
        <img src="https://cdn.magicpatterns.com/uploads/f2WswFoBnvLSR7DDANnFPV/ChatGPT_Image_23_ago_2026__10_47_59-removebg-preview.webp" alt="El Kit del Taller Rentable: colección de 5 tomos y 5 bonos con planos de carpintería" width={500} height={500} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-md sm:max-w-lg" data-id="element-112" data-mp="inpidhvkum3z" />

        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.26
      }} className="mt-6 flex flex-col items-center" data-id="element-113" data-mp="30mp97kspe8mz">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} showArrow={false} data-id="element-114" data-mp="2qu9s0pp8do35">
            Quiero el Kit por 19€
          </PrimaryButton>
          <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-115" data-mp="2huedcawgvayd">
            Acceso inmediato · Pago único · 100% Práctico
          </p>
        </m.div>
      </div>
    </header>;
}